export const collaboratorRole = [
  'adv',
  'adv-distanciel',
  'responsable-magasin',
  'chef-secteur',
] as const
export type CollaboratorRole = (typeof collaboratorRole)[number]

export const collaboratorRoleLabel: Record<CollaboratorRole, string> = {
  adv: 'Animateur des Ventes',
  'adv-distanciel': 'Animateur des Ventes - Distanciel',
  'responsable-magasin': 'Manager de Boutiques',
  'chef-secteur': 'Responsable de Secteur',
}

// Rôles au sommet de la hiérarchie (directeur / gérant) : pas de N+1 obligatoire.
// Pour tous les autres rôles, le manager (managerId) reste requis.
export const rolesWithoutMandatoryManager: CollaboratorRole[] = [
  'responsable-magasin',
  'chef-secteur',
]
